import Card from 'react-bootstrap/Card';
import './styles/menu.css';

function RoomList(props){
    return(
        <Card id="menu_item" style={{ width: '18rem' }} border="secondary" onClick={() => {props.handle_room_select(props.room_id)}}>
            <Card.Body>
                <Card.Title>{props.room_name}</Card.Title>
                <Card.Subtitle className="mb-2 text-muted">#{props.room_id}</Card.Subtitle>
            </Card.Body>
        </Card>
    );
}
export default RoomList;